import React from 'react'
import styles from '../Proj1Folder/Proj1.module.css'
import elite1 from '../../Images/elite01.jpeg'
import elite2 from '../../Images/elite02.jpeg'







export default function EliteArtistsResidence() {
  return (

    <>
        <div className="container my-5 py-5 ">
          <div className="row  align-items-center">
            <div className="col-md-6">
            <h3 className={`${styles.color} my-3`}> Artists' grave house ​</h3>
                <p> Project description: : admin and production hall     </p>                
                <p>Type of works : architectural , civil and electromechanical design </p>
            </div>
            <div className="col-md-6">
                <img src={elite1} alt="achegy" className='img-fluid'/>
            </div>   

          </div>
       <div className="row my-5">
          <div className="col-md-6 my-1 text-center">
               <img src={elite2} alt="achegy" className={`${styles.imgSizeProj}`}/> 
            </div>
            <div className="col-md-6 my-1 text-center">
               <img src={elite1} alt="achegy" className={`${styles.imgSizeProj}`}/> 
            </div>
           
       
          </div>
        </div>

    </>
  )
}
